export interface Environment {
    frontendDomain: string;
    apiDomain: string;
    useSsl: boolean;
    vapidKey: string;
}

export const environment = window["env" as keyof typeof window];